// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"K4-z","colorTextValue":"L4-z","swatches":"M4-z","collapseLink":"N4-z","isCollapsed":"O4-z","dropdown":"P4-z","disabled":"Q4-z"};